/**
 * Digest session helpers.
 *
 * Weekly Digest sessions are created by the backend runner and owned by the
 * system user "system-digest". These helpers identify digest sessions so the
 * UI can render them distinctly from regular and team chat sessions.
 */

/** The synthetic user ID assigned to all system-generated digest sessions. */
export const DIGEST_SYSTEM_USER_ID = "system-digest";

/**
 * Returns true when the given session is a system-generated Weekly Digest.
 *
 * A digest session is identified by its ownerId matching the system user ID
 * exactly. Returns false for any other ownerId, including undefined and null,
 * without throwing.
 */
export function isDigestSession(session: { ownerId?: string | null }): boolean {
	return session.ownerId === DIGEST_SYSTEM_USER_ID;
}
